<template>
  <div>
    <DragDrop
      :readonly="readonly"
      :isEmployer="isEmployer"
      @add="$emit('add', $event)"
    />

    <UploadedFiles
      :files="files"
      @remove="$emit('remove', $event)"
    />

    <div class="cooperation-page__actions-wrapper">
      <button
        class="base-btn base-btn--green"
        :class="{ '_loading': isLoading }"
        :disabled="!files.filter((f) => f.step === step).length || readonly"
        @click="$emit('ready')"
      >
        <BasePreloader v-if="isLoading"/>
        <span class="base-btn__text">{{ isEmployer ? $tCooperation('Submit') : $tCooperation('Ready') }}</span>
      </button>

      <template v-if="!isEmployer">
        <button
          class="base-btn base-btn--outline-green cooperation-page__action-ticket"
          :class="{ '-enabled': isTicketMode }"
          @click="toggleTicketVisibility()"
        >
          <span class="base-btn__text">{{$tCooperation('Buy a ticket')}}</span>
        </button>

        <button
          class="base-btn base-btn--outline-green"
        >
          <span class="base-btn__text">{{$tCooperation('Buy insurance')}}</span>
        </button>
      </template>
    </div>

    <div v-if="isTicketMode" class="cooperation-page__ticket-widget-wrapper">
      <BaseSvg
        class="cooperation-page__ticket-widget-close"
        name="ico-close"
        @click.native="isTicketMode = false"
      />

      <Widget/>
    </div>
  </div>
</template>

<script>
  import DragDrop from './DragDrop';
  import UploadedFiles from './UploadedFiles';
  import Widget from './Widget';

  export default {
    components: { DragDrop, UploadedFiles, Widget },
    props: [ 'readonly', 'files', 'step', 'isEmployer', 'isLoading' ],

    data() {
      return {
        isTicketMode: false
      };
    },

    methods: {
      toggleTicketVisibility() {
        this.isTicketMode = !this.isTicketMode;
        this.$emit('toggleTicketVisibility', this.isTicketMode);
      }
    }
  };
</script>
